module.exports = __webpack_public_path__ + "img/cbam-bg-en.35e810db.png";